import localeText from '@locale';
import SessionStore from '~/stores/SessionStore';
import Error from '~/components/Modal/Error';
import {sessionExpired, querystring, redirectToSSO} from '~/utils/tools';

const ssoRedirect = querystring('ssoRedirect' || 'sso-redirect' || 'ssoredirect');

class SessionMessgaeModal {
  running = false;

  actionHandel = () => {
    this.running = false;
    sessionExpired();
    return Promise.reject();
  };

  show = ({isSessionExpired = false, sessionConflictMessage = ''}) => {
    const accessToken = SessionStore.tokenInCookie;
    if (!this.running && accessToken) {
      if (ssoRedirect) {
        redirectToSSO(ssoRedirect);
      } else {
        this.running = true;
        Error({
          title: isSessionExpired ? localeText('COMMON.TITLE_TOKEN_EXPIRED') : localeText('COMMON.TITLE_SESSION_CONFLICT'),
          content: isSessionExpired ? localeText('COMMON.TXT_EXPIRED_CONTENT') : localeText('COMMON.TXT_SESSION_CONFLICT', sessionConflictMessage),
          onOk: this.actionHandel,
          onCancel: this.actionHandel,
          className: 'session-message-modal',
          zIndex: 9999
        });
        return Promise.reject();
      }
    }
    if (!accessToken) { // 用户未登录状态下，直接进入登录页面
      if (ssoRedirect) {
        redirectToSSO(ssoRedirect);
      } else {
        sessionExpired();
      }
    }
  };
}

export default new SessionMessgaeModal();
